module.exports = __webpack_public_path__ + "img/Badge-iOS.fca438b6.svg";